import React from "react";

type Props = {
  children: React.ReactNode;
  bigger?: boolean;
};
const BodyTitle: React.FC<Props> = (props) => {
  return (
    <p className={"font-sans font-bold leading-8 my-2 text-2xl"}>
      ★ {props.children} ★
    </p>
  );
};

export default BodyTitle;
